import React, { Component } from "react";
import Spinner from "@atlaskit/spinner";

export default class Loading extends Component {
  render() {
    return <Spinner size={this.props.size || "xlarge"} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/loading/Loading.js